/**
 * CMCD parameter name.
 *
 * @public
 */
export const CMCD_PARAM = 'CMCD'
